import React from "react";
import { Link } from "react-router-dom";
import './About.css'; 


const About = () => {

    return (
        <section className="about">
            <h2>About Genesys Music</h2>
            
            <p>Our mission is to provide high-quality alternatives to over-marketed products at an unbeatable price.</p>
            
            <p>Genesys guitars are manufactured on the same production line as some of the world's biggest known brands today. 
                We choose only the best exotic timbers and take maximum pride in our quality control procedures. 
                We are also proud to incorporate such names as Wilkinson and Seymour Duncan in a product that we know will give you the return you are looking for in a guitar.</p>
            
            <p>Genesys Music is a 100% Australian-owned company and has a combined experience of over 40 years in the Australian market.</p>
            
            <p>
                Our experience and presence both here and offshore reinforce our ability to ensure that only the finest quality instrument is available from your local dealer. 
                <Link to="/feedback"> Click here</Link> for feedback from other satisfied Genesys Music customers.
            </p>
        </section>
    );
}
export default About;
